import { Violation } from "./validation-violation";

export class ValidationException {
    violations : Violation[];

    constructor(violations : Violation[]){
        this.violations = violations;
    }
}